import { HeaderInfoService } from './../../../servicios/header-info.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pagina-visitantes',
  templateUrl: './pagina-visitantes.component.html',
  styleUrls: ['./pagina-visitantes.component.scss']
})
export class PaginaVisitantesComponent implements OnInit {

  public displayedColumns: any[] = [
    {
      nombre: 'nombreVisitante',
      titulo: 'Nombre Visitante',
      valueFieldName: 'name'
    },
    {
      nombre: 'area',
      titulo: 'Área',
      valueFieldName: 'area_name'
    },
    {
      nombre: 'apartamento',
      titulo: 'Apt/Casa',
      valueFieldName: 'site_name'
    },
    {
      nombre: 'documento',
      titulo: 'No. de identidad',
      valueFieldName: 'number_document'
    },
    {
      nombre: 'fechaLlegada',
      titulo: 'Fecha/Hora llegada',
      valueFieldName: 'hour_checkin'
    },
    {
      nombre: 'fechaSalida',
      titulo: 'Fecha/Hora salida',
      valueFieldName: 'hour_checkout'
    },
    {
      nombre: 'vehiculo',
      titulo: 'Vehículo',
      valueFieldName: 'vehiculo'
    },
    {
      nombre: 'comentario',
      titulo: 'Comentario',
      valueFieldName: 'note'
    },
  ];

  constructor(private headerInfoService: HeaderInfoService) { }

  ngOnInit() {
    this.headerInfoService.cambiarTituloPagina("VISITANTES");
    this.headerInfoService.cambiarTituloTarjeta("¡Bienvenido a visitantes!");
    this.headerInfoService.cambiarTextoTarjeta("Lorem ipsum dolor sit amet, consectetur adipiscing elit. Maecenas varius tortor nibh, sit amet tempor nibh finibus et. Aenean eu enim justo.");
    this.headerInfoService.cambiarImagenTarjeta('./../../../../assets/header/pagina-principal-lugares.svg');
  }

}
